import React, {useCallback, useEffect} from "react";
import {connect} from "react-redux";

import {setJobPurchaseOrderInvoiceFile, setJobPurchaseOrderInvoiceNumber} from "../jobPurchaseOrderActions";
import {getParsedJobOrder} from "../jobOrderFunctions";
import JobPurchaseOrderInvoiceFileUpload from "./JobPurchaseOrderInvoiceFileUpload";


const JobPurchaseOrderInvoice = (props) => {

  const {purchaseOrderInvoiceNumber, setJobPurchaseOrderInvoiceNumber, job} = props;

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  const onInvoiceChange = useCallback((event) => {
    setJobPurchaseOrderInvoiceNumber(event.target.value);
  }, [setJobPurchaseOrderInvoiceNumber]);

  const updateInvoiceData = async () => {
    if (jobOrder.invoiceId) {
      setJobPurchaseOrderInvoiceNumber(jobOrder.invoiceId);
    }
  }

  useEffect(() => {
    updateInvoiceData();
  }, []);

  return (
    <div className="flex relative job-payment__content flex-item pl-1 pt-1 pr-1 border-box">
      <div className="job-payment__content-left border-box pr-1 text-left font--15 flex-item flex-item--50">
        <p className="m-0">You are about to issue an invoice to <br/><span className="bold">{jobOrder.parentFabricatorName}</span>.</p>
        <p className="mt-05">Please enter the invoice number exactly as it appears on the invoice and verify both the PO Number and the amount</p>
        <div className="mt-1 mb-1 nowrap pl-1 pr-1 pt-15 pb-15 radius-10 job-board-edit-popup__po-number">
          PO Number: <span className="bold">{jobOrder.orderId}</span>
        </div>
        <div className="">
          <label htmlFor="purchaseOrderInvoiceNumber" className="material__label">
            Invoice Number
          </label>
          <input className="material__input"
                 type="text"
                 placeholder=""
                 name="invoiceNumber"
                 id="purchaseOrderInvoiceNumber"
                 value={purchaseOrderInvoiceNumber}
                 onChange={onInvoiceChange}/>
        </div>
      </div>
      <div className="flex-item border-box pl-1">
        <JobPurchaseOrderInvoiceFileUpload/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {purchaseOrderInvoiceNumber} = store.jobPurchaseOrderPopupState;
  const {job} = store.jobEditPopupState;

  return {
    purchaseOrderInvoiceNumber,
    job,
  };
};

const mapDispatchToProps = {
  setJobPurchaseOrderInvoiceNumber,
  setJobPurchaseOrderInvoiceFile,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPurchaseOrderInvoice)
)
